import styled from 'styled-components'

import { Props } from './Typography'

type StyledProps = Pick<Props, 'variant' | 'fontWeight' | 'color' | 'fontFamily'>

export const StyledTypography = styled.div<StyledProps>`
  font-size: ${p => {
    switch (p.variant) {
      case 'title':
        return `${p.theme.typography.size.Title1}px`
      case 'title2':
        return `${p.theme.typography.size.Title2}px`
      case 'subtitle1':
        return `${p.theme.typography.size.Subtitle1}px`
      case 'subtitle2':
        return `${p.theme.typography.size.Subtitle2}px`
      case 'label1':
        return `${p.theme.typography.size.Label1}px`
      case 'label2':
        return `${p.theme.typography.size.Label2}px`
      case 'description':
        return `${p.theme.typography.size.Description}px`
      case 'body':
        return `${p.theme.typography.size.Body}px`
      case 'caption':
        return `${p.theme.typography.size.Caption1}px`
      case 'caption2':
        return `${p.theme.typography.size.Caption2}px`
      default:
        return `${p.theme.typography.size.Description}px`
    }
  }};

  font-weight: ${p =>
    p.fontWeight === 'light'
      ? p.theme.typography.weight.Light
      : p.fontWeight === 'semiBold'
        ? p.theme.typography.weight.SemiBold
        : p.fontWeight === 'bold'
          ? p.theme.typography.weight.Bold
          : p.fontWeight === 'medium'
            ? p.theme.typography.weight.Medium
            : p.theme.typography.weight.Regular};

  font-family: ${p => p.theme.typography.family.Poppins};

  color: ${p => {
    switch (p.color) {
      case 'primary':
        return p.theme.colors.text.primary
      case 'secondary':
        return p.theme.colors.text.secondary
      case 'danger':
        return p.theme.colors.text.danger
      case 'warning':
        return p.theme.colors.text.danger1
      case 'success':
        return p.theme.colors.text.success
      default:
        return p.theme.colors.text.primary
    }
  }};
`
